import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormService } from 'src/app/services/form.service';
import { IncidentService } from 'src/app/services/incident.service';
import { ToastService } from 'src/app/services/toast.service';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { DropdownService } from 'src/app/services/dropdown.service';

@Component({
  selector: 'app-mars-incident',
  templateUrl: './mars-incident.component.html',
  styleUrls: ['./mars-incident.component.scss']
})
export class MarsIncidentComponent implements OnInit, OnDestroy {
  constructor(
    private formService: FormService,
    private route: ActivatedRoute,
    private incidentService: IncidentService,
    private toast: ToastService,
    private dropdownService: DropdownService,
    private router: Router
  ) {}

  marsIncidentForm: FormGroup = this.formService.marsIncidentForm;
  incidentSubscription: any;
  isLoading = false;
  riggerSubscription: any;
  jumperSub: any;
  jumpersSub: any;
  basesSub: any;
  manufacturersSub: any;
  reserveChuteSub: any;
  jumperBasesSub: any;
  selectedAircraftSub: any;
  user = JSON.parse(window.sessionStorage.getItem('userInfo'));
  madbIncidentSub: any;  

  modal = {
    active: false,
    data: {
      title: 'Please Note',
      listItems: [
        'If an incident is finalized, then it is no longer editable.',
        'Only MARS admin can convert an incident back to a draft for editing.',
        'If the incident still has values that need to be updated by yourself or others, just save the draft.'
      ],
      confirm: 'Finalize',
      confirmIcon: 'lock',
      secondaryOption: 'Save Draft',
      secondaryIcon: 'schedule',
      deny: 'Cancel'
    }
  }

  ngOnInit(): void {
    this.marsIncidentForm.enable();
    this.marsIncidentForm.reset();
    if (this.route.snapshot.params.id) {
      this.isLoading = true;
      this.incidentSubscription = this.incidentService
        .getSingleMarsIncident(this.route.snapshot.params.id)
        .subscribe((incident) => {
          this.marsIncidentForm.patchValue(incident);
          // here we are disabling the form if the status is 1, which means the incident is finalized
          if (this.formService.marsIncidentForm.get('status').value === 1) {
            this.marsIncidentForm.disable();
          }
          if (this.formService.marsIncidentForm.get('madbIncident') !== null) {
            if (incident.madbIncidentId !== null && incident.madbIncidentId !== 0) {
              this.marsIncidentForm.get('madbIncident').patchValue(this.formService.marsIncidentForm.get('madbIncident').value);
            
              this.madbIncidentSub = this.incidentService.getSingleMadbIncident(incident.madbIncidentId).subscribe({
                next: (madbIncident) => {
                  let newMadbIncident = {...madbIncident,
                    incidentId: madbIncident._id,
                    incidentName: madbIncident._nameofIncident,
                    baseCode: madbIncident._baseCode,
                  }
  
                  this.marsIncidentForm.get('madbIncident').patchValue(newMadbIncident);
                  this.marsIncidentForm.get('madbIncidentId').patchValue(incident.madbIncidentId);
                  this.marsIncidentForm.get('mission').patchValue(madbIncident._mission);
                  this.marsIncidentForm.get('mode').patchValue(madbIncident._mode);
                  this.marsIncidentForm.get('toArea').patchValue(madbIncident._areaId);
                  this.marsIncidentForm.get('yardsDrift').patchValue(madbIncident._yardsofDrift);
                  
                },
                error: (error) => {
                  this.toast.show(error.error || error, 'error')
                }
              });
            }
            this.isLoading = false;
          }
          // this is where we setup a lot of our details for filling in the form in edit mode
          // many of these could be refactored to call for the items by id, instead of calling for the arrays and filtering them
          // also, this.dropdownService.getMadbHomeBases() is called 4 times in this function, which is not ideal
          if (this.marsIncidentForm.get('travelModeId').value) {
            this.selectedAircraftSub = this.dropdownService.getAircrafts().subscribe((aircrafts) => {
              const aircraft = aircrafts?.value?.filter((aircraft) => aircraft.id === this.marsIncidentForm.get('travelModeId').value)[0] || null;
              this.marsIncidentForm.get('aircraft')?.patchValue(aircraft);
            })
          }
          if (this.marsIncidentForm.get('jumperBaseId').value) {
            this.jumperBasesSub = this.dropdownService.getMadbHomeBases().subscribe({
              next: (bases) => {
                this.marsIncidentForm.get('jumperBaseDetails').patchValue(bases?.filter((base) => base.id === parseFloat(this.marsIncidentForm.get('jumperBaseId').value))[0]);
              }
            });
          };
          // this sets the main jumper details if there is a personnelId in edit mode
          if (this.marsIncidentForm.get('personnelId').value) {
            this.jumperSub = this.dropdownService.getJumperById(this.marsIncidentForm.get('personnelId').value, this.marsIncidentForm.get('malfunctionDate').value).subscribe({
              next: (jumper: any) => {
                this.marsIncidentForm.get('jumperDetails').patchValue(jumper);
                if(this.marsIncidentForm.get('jumperBaseId').value !== jumper.baseId) {
                  console.log('tick', jumper);
                  this.dropdownService.getBaseById(jumper.baseId).subscribe({
                    next: (base) => {
                      console.log('base from call', base);
                      base.text = base.name;
                      base.value = jumper.baseId;
                      base.code = base.value;
                      base.baseCode = base.affiliated;
                      base.baseId = base.id;
                      this.marsIncidentForm.get('jumperBaseDetails').patchValue(base);
                    }
                  })
                }
              }
            });
          }

          // this sets the main parachute riggers details if we are in edit mode and there is a main rigger id
          if (incident.mainRiggerId !== null) {
            this.jumpersSub = this.dropdownService.getAllJumpers().subscribe({
              next: (jumpers) => {
                this.marsIncidentForm.get('mainRiggerDetails').patchValue(jumpers?.value.find((jumper) => jumper.id === incident.mainRiggerId));
              }
            });
          };
          // this sets the main rigger location details if we are in edit mode and there is a rig location id
          if (incident.mainRigLocId !== null) {
            this.basesSub = this.dropdownService.getBaseById(incident.mainRigLocId).subscribe({
              next: (base) => {
                this.marsIncidentForm.get('mainRigLocDetails').patchValue(base);
              }
            });
          }
          // this sets the main rigger spike location details if we are in edit mode and there is a mainRiggerSpikeBaseId
          if (this.marsIncidentForm.get('mainRiggerSpikeBaseId').value) {
            this.basesSub = this.dropdownService.getBaseById(this.marsIncidentForm.get('mainRiggerSpikeBaseId').value).subscribe({
              next: (base) => {
                this.marsIncidentForm.get('mainRiggerSpikeBaseDetails').patchValue(base);
              }
            });
          }
          if (this.marsIncidentForm.get('mainRigManufId').value) {
            let name
            switch (this.marsIncidentForm.get('mainRigManufId').value) {
              case 1:
                name = 'Airborne Systems'
                break;
              case 2:
                name = 'Performance Designs'
                break;
              case 3:
                name = 'Irvin'
                break;
              case 4:
                name = 'Other'
                break;
              case 5:
                name = 'Eiff'
                break;
              case 6:
                name = 'Para Flite'
                break;
              case 7:
                name = 'Quantum'
                break;
              case 8:
                name = 'Strong Enterprise'
                break;
              default:
                name = ''
                break;
            }
            const manufacturerFormattedDetails = {
              id: parseFloat(this.marsIncidentForm.get('mainRigManufId').value),
              name: name 
            }
            this.marsIncidentForm.get('mainRigManufDetails').patchValue(manufacturerFormattedDetails);
          }

          // this sets the drogue rigger spike location detials if we are in edit mode and there is a riggingLocationsSpike
          if (this.marsIncidentForm.get('drgRiggerSpikeBaseID').value) {
            this.basesSub = this.dropdownService.getBaseById(this.marsIncidentForm.get('drgRiggerSpikeBaseID')?.value).subscribe({
              next: (base) => {
                this.marsIncidentForm.get('drgRiggerSpikeBaseDetails').patchValue(base);
              }
            });
          }
          // this sets the drogue parachute details if we are in edit mode and there is a drogue parachute id
          if (incident.drgNum) {
            this.jumpersSub = this.dropdownService.getDrogueParachutes().subscribe({
              next: (chutes) => {
                this.marsIncidentForm.get('drgName').patchValue(chutes?.value.find((chute) => chute.drogue === incident.drgNum));
              }
            });
          }
          // this sets the drogue parachute rigger details if we are in edit mode and there is a drogue rigger id
          //if (this.marsIncidentForm.get('drgRiggerId').value) {
          if (incident.drgRiggerId !== null) {
            this.jumpersSub = this.dropdownService.getAllJumpers().subscribe({
              next: (jumpers) => {
                //this.marsIncidentForm.get('drgRiggerDetails').patchValue(jumpers?.value.filter((jumper) => jumper.id === parseFloat(this.marsIncidentForm.get('drgRiggerId').value))[0]);
                this.marsIncidentForm.get('drgRiggerDetails').patchValue(jumpers?.value.filter((jumper) => jumper.id === incident.drgRiggerId)[0]);
              }
            });
          }
          // this sets the drogue manufacturer name if there is one in edit mode. the manufacturer list was hardcoded in the form, so the same was reproduced here. Should this list be from a backend call?
          if (this.marsIncidentForm.get('drgRigManufId').value) {
            let name
            switch (this.marsIncidentForm.get('drgRigManufId').value) {
              case 1:
                name = 'BRS'
                break;
              case 2:
                name = 'G7T'
                break;
              case 3:
                name = 'Wingate'
                break;
              case 4:
                name = 'Other'
                break;
              default:
                name = ''
                break;
            }
           const manufacturerFormattedDetails = {
              id: parseFloat(this.marsIncidentForm.get('drgRigManufId').value),
              name: name 
            }
            this.marsIncidentForm.get('drgManufDetails').patchValue(manufacturerFormattedDetails);
          }
          // this sets the drogue location details if we are in edit mode and there is a drogue location id
          if (this.marsIncidentForm.get('drgRigLocationId').value) {
            this.basesSub = this.dropdownService.getMadbHomeBases().subscribe({
              next: (bases) => {
                this.marsIncidentForm.get('drgRigLocationDetails').patchValue(bases?.filter((base) => base.id === parseFloat(this.marsIncidentForm.get('drgRigLocationId').value))[0]);
              }
            });
          }

          // this sets the reserve parachute details if we are in edit mode and there is a reserve parachute id
          if (incident.reserveNum) {
            this.reserveChuteSub = this.dropdownService.getReserveParachutes().subscribe({
              next: (chutes) => {
                this.marsIncidentForm.get('reserveNum').patchValue(incident.reserveNum);
                this.marsIncidentForm.get('reserveParachuteDetails').patchValue(chutes?.value.filter((chute) => chute.reserve === incident.reserveNum)[0]);
              }
            });
          }
          // this sets the reserve parachute manufacturer details if we are in edit mode and there is a reserve parachute manufacturer id
          if (this.marsIncidentForm.get('reserveRigManufId').value) {
            let name
            switch (this.marsIncidentForm.get('reserveRigManufId').value) {
              case 1:
                name = 'Airborne Systems'
                break;
              case 2:
                name = 'Butler'
                break;
              case 3:
                name = 'Para Flight'
                break;
              case 4:
                name = 'Other'
                break;
              default:
                name = ''
                break;
            }
            const manufacturerFormattedDetails = {
              id: parseFloat(this.marsIncidentForm.get('reserveRigManufId').value),
              name: name 
            }
            this.marsIncidentForm.get('reserveRigManufDetails').patchValue(manufacturerFormattedDetails);
          }

          // this sets the reserve parachute rigger details if we are in edit mode and there is a reserve parachute rigger id
          if (incident.reserveRiggerId) {
            this.jumpersSub = this.dropdownService.getAllJumpers().subscribe({
              next: (jumpers) => {
                this.marsIncidentForm.get('reserveRiggerDetails').patchValue(jumpers?.value.find((jumper) => jumper.id === incident.reserveRiggerId));
              }
            });
          }
          // this sets the reserve parachute location details if we are in edit mode and there is a reserve parachute location id
          if (this.marsIncidentForm.get('reserveRigLocId').value) {
            this.basesSub = this.dropdownService.getMadbHomeBases().subscribe({
              next: (bases) => {
                this.marsIncidentForm.get('reserveRigLocDetails').patchValue(bases?.filter((base) => base.id === parseFloat(this.marsIncidentForm.get('reserveRigLocId').value))[0]);
              }
            });
          }
        });
    } else {
      this.marsIncidentForm.patchValue(this.formService.marsIncidentFormInit);
    }
  }

  ngOnDestroy(): void {
    this.marsIncidentForm.get('incidentId').reset(0);
    this.marsIncidentForm.get('classificationId').reset(0);
    this.marsIncidentForm.get('categoryId').reset(0);
    this.marsIncidentForm.get('classificationTypeId').reset(0);
    this.marsIncidentForm.get('malfunctionTypeId').reset(0);
    this.marsIncidentForm.get('homeBaseId').reset(0);
    this.marsIncidentForm.get('categoryId').disable();
    this.incidentSubscription?.unsubscribe();
    this.riggerSubscription?.unsubscribe();
    this.jumpersSub?.unsubscribe();
    this.basesSub?.unsubscribe();
    this.manufacturersSub?.unsubscribe();
    this.reserveChuteSub?.unsubscribe();
    this.jumperBasesSub?.unsubscribe();
    this.jumperSub?.unsubscribe();
    this.selectedAircraftSub?.unsubscribe();
    this.madbIncidentSub?.unsubscribe();
  }

  // this is a quick validation for new incidents on their milestone save point
  checkInitialValidation() {
    if (this.marsIncidentForm.get('malfunctionDate').value === null || this.marsIncidentForm.get('homeBase1').value === null || this.marsIncidentForm.get('classificationId').value === null|| this.marsIncidentForm.get('classificationId').value === 0 || this.marsIncidentForm.get('categoryId').value === null || this.marsIncidentForm.get('classificationTypeId').value === null ) {
      return false;
    } else {
      return true;
    }
  }

  // this is okay, but there is a lot of repeated code that could be refactored into a cool function. it is, however, currently functional
  saveIncident(finalize: 0 | 1) {
    this.modal.active = false;
    // we now allow for blank/0 selections for classification, type, etc - don't allow saving here if we're editing
    //  an unclassified incident, but failed to fill in all fields
    if (!this.checkInitialValidation()) {
      this.toast.show('Please Ensure You Have Selected Classificaiton, Type and Catetory', 'error'); 
      return;
    }

    // here we remove any comma's or decimals from the jumpSpotElevationMSL
    const jumpElevationNumber = this.marsIncidentForm.get('jumpSpotElevationMSL')?.value?.toString()?.replace(/,/g, '')?.replace(/\./g, '')
    if (jumpElevationNumber) {
      this.marsIncidentForm.get('jumpSpotElevationMSL').patchValue(jumpElevationNumber)
    }
    this.isLoading = true;
    // here we create an uploadListCount for tracking the loading state
    const uploadList = [this.marsIncidentForm.get('pic1toUpload').value, this.marsIncidentForm.get('pic2toUpload').value, this.marsIncidentForm.get('pic3toUpload').value, this.marsIncidentForm.get('videoToUpload').value];
    let uploadListCount = uploadList.filter((upload) => ((upload !== null) && (upload !== ''))).length;
    // if finalizing draft, status should be set to 1. if updating draft, status should be set to 0. 
    this.marsIncidentForm.get('status').patchValue(finalize);
    if (this.route.snapshot.params.id) {
      this.marsIncidentForm.get('modifyUser').patchValue(this.formService.userInfo.email);
      this.marsIncidentForm
      .get('modifyDate')
      .patchValue(formatDate(new Date(), 'MM/dd/yyyy', 'en-US'));
      this.incidentService.updateMarsIncident(this.marsIncidentForm.value).subscribe({
        next: (response) => {
          // here we are formatting the jumpSpotElevation to a locale string for display
          if (this.marsIncidentForm.get('jumpSpotElevationMSL').value) {
            this?.marsIncidentForm?.get('jumpSpotElevationMSL')?.patchValue(parseFloat(this?.marsIncidentForm?.get('jumpSpotElevationMSL')?.value)?.toLocaleString());
          }
          // if there are no images or videos to upload, we set isLoading to false and throw a success toast
          if (uploadListCount === 0) {
            this.toast.show('Incident successfully updated!', 'success');
            this.isLoading = false;
          }
          const incidentId = response.split(' ')[1];
          if (this.marsIncidentForm.get('pic1toUpload').value) {
            this.incidentService.saveIncidentImage(this.marsIncidentForm.get('pic1toUpload').value, 1, parseInt(incidentId)).subscribe({
              next: (response) => {
                // we reduce the uploadListCount by 1 for each successful upload
                uploadListCount -= 1;
                if (uploadListCount === 0) {
                  this.toast.show('Incident successfully updated!', 'success');
                  this.isLoading = false;
                }
              },
              error: (error) => {
                this.toast.show(error.error || error, 'error')
                this.isLoading = false;
                console.log('error', error);
              }
            });
          }
          if (this.marsIncidentForm.get('pic2toUpload').value) {
            this.incidentService.saveIncidentImage(this.marsIncidentForm.get('pic2toUpload').value, 2, parseInt(incidentId)).subscribe({
              next: (response) => {
                uploadListCount -= 1;
                if (uploadListCount === 0) {
                  this.toast.show('Incident successfully updated!', 'success');
                  this.isLoading = false;
                }
              },
              error: (error) => {
                this.toast.show(error.error || error, 'error')
                this.isLoading = false;
                console.log('error', error);
              }
            });
          }
          if (this.marsIncidentForm.get('pic3toUpload').value) {
            this.incidentService.saveIncidentImage(this.marsIncidentForm.get('pic3toUpload').value, 3, parseInt(incidentId)).subscribe({
              next: (response) => {
                uploadListCount -= 1;
                if (uploadListCount === 0) {
                  this.toast.show('Incident successfully updated!', 'success');
                  this.isLoading = false;
                }
              },
              error: (error) => {
                this.toast.show(error.error || error, 'error')
                this.isLoading = false;
                console.log('error', error);
              }
            });
          }
          if (this.marsIncidentForm.get('videoToUpload').value) {
            this.incidentService.saveIncidentImage(this.marsIncidentForm.get('videoToUpload').value, 4, parseInt(incidentId)).subscribe({
              next: (response) => {
                uploadListCount -= 1;
                if (uploadListCount === 0) {
                  this.toast.show('Incident successfully updated!', 'success');
                  this.isLoading = false;
                }
              },
              error: (error) => {
                this.toast.show(error.error || error, 'error')
                this.isLoading = false;
                console.log('error', error);
              }
            });
          }
          // here we disable the form if the status is 1, which means the incident is finalized, otherwise we enable the form for draft mode
          this.marsIncidentForm.get('status').value === 1 ? this.marsIncidentForm.disable() : this.marsIncidentForm.enable();
        },
        error: (error) => {
          this.toast.show(error.error.message || error.error || error, 'error')
          this.isLoading = false;
          console.log('error', error);
        }
      });
    } else {
      this.incidentService.saveMarsIncident(this.marsIncidentForm.value).subscribe({
        next: (response) => {
          this.toast.show(response, 'success');
          const incidentId = response.split(' ')[1];
          this.isLoading = false;
          this.router.navigate(['mars/incident/' + incidentId]);
        },
        error: (error) => {
          this.toast.show(error.error.detail || error, 'error')
          this.isLoading = false;
          console.log('error', error);
        }
      });
    }
  }
}
